module.exports = __webpack_public_path__ + "assets/img/page1-first-tab-neutral-d291650a.png";